import { Navigate } from "react-router-dom";
import { BUDGET_MODULE_PATHS } from "../constants/budgetModule";
import { useAuth } from "../state/AuthContext";
import { isAccountantUser } from "../utils/userRole";

const MainUserRoute = ({ children }) => {
  const { user } = useAuth();

  if (!user) {
    return <Navigate to={BUDGET_MODULE_PATHS.entry} replace />;
  }

  if (isAccountantUser(user)) {
    return <Navigate to={BUDGET_MODULE_PATHS.planner} replace />;
  }

  return children;
};

export default MainUserRoute;
